import React from "react";

/** Shared typography for project-tab section titles (Documents model). */
export const PROJECT_SECTION_TITLE_CLASSNAME =
  "text-2xl font-bold text-gray-950";

/**
 * Render a standardized project-tab section title (text only).
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - Title text.
 * @param {"h1"|"h2"|"h3"} [props.as="h2"] - Heading element.
 * @param {string} [props.className=""] - Extra classes (e.g. margin).
 * @returns {JSX.Element}
 */
const ProjectSectionTitle = ({ children, as: Tag = "h2", className = "" }) => (
  <Tag
    className={`${PROJECT_SECTION_TITLE_CLASSNAME} ${className}`.trim()}
  >
    {children}
  </Tag>
);

export default ProjectSectionTitle;
